/*
* @Description: 协议SAP字段默认配置管理 新增、编辑弹出层
* @Author: gzw
* @Date: 2025-08-06
*/
<template>
  <el-dialog
    :title="title" :visible.sync="visible" @close="handleClose"
    width="600px">
    <el-form
      class="form"
      :model="form"
      ref="form"
      :rules="rules"
      :label-width="formLabelWidth">
      <el-form-item label="体系名称" prop="systemName">
        <el-select
          class="form-input"
          v-model="form.systemName"
          placeholder="请选择体系名称"
          @change="handleSystemNameChange">
          <el-option
            v-for="item in systemNameOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="业务模式" prop="businessModel">
        <el-select
          class="form-input"
          v-model="form.businessModel"
          placeholder="请选择业务模式">
          <el-option
            v-for="item in businessModelOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="经营组织名称" prop="deptName">
        <el-select
          class="form-input"
          v-model="form.deptName"
          placeholder="请选择经营组织"
          filterable
          clearable
          @change="handleDeptChange">
          <el-option
            v-for="item in deptOptions"
            :key="item.id"
            :label="item.deptName"
            :value="item.deptName">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="SAP订单类型名称" prop="sapOrderTypeName">
        <el-select
          class="form-input"
          v-model="form.sapOrderType"
          placeholder="请选择SAP订单类型"
          @change="handleSapOrderTypeChange">
          <el-option
            v-for="item in sapOrderTypeOptions"
            :key="item.code"
            :label="`${item.code}(${item.name})`"
            :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="SAP项目类别名称" prop="sapProductTypeName">
        <el-select
          class="form-input"
          v-model="form.sapProductTypeName"
          placeholder="请选择SAP项目类别"
          @change="handleSapProductTypeChange">
          <el-option
            v-for="item in filteredSapProductTypeOptions"
            :key="item.name"
            :label="item.code ? `${item.code}(${item.name})` : item.name"
            :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="SAP客户订单类型名称" prop="sapBusinessTypeName">
        <el-select
          class="form-input"
          v-model="form.sapBusinessType"
          placeholder="请选择SAP客户订单类型"
          @change="handleSapBusinessTypeChange">
          <el-option
            v-for="item in sapBusinessTypeOptions"
            :key="item.code"
            :label="item.code ? `${item.code}(${item.name})` : item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="SAP销售组织" prop="sapSaleOrg">
        <el-select
          class="form-input"
          v-model="form.sapSaleOrg"
          placeholder="请选择SAP销售组织"
          @change="handleSapSaleOrgChange">
          <el-option
            v-for="item in sapSaleOrgOptions"
            :key="item.code || item.name"
            :label="item.name"
            :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'addOrEditDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      visible: this.show,
      formLabelWidth: '140px',
      form: {},
      baseForm: {
        systemName: '',
        businessModel: '',
        deptName: '',
        deptId: '',
        sapOrderType: '',
        sapOrderTypeName: '',
        sapProductTypeName: '',
        sapBusinessType: '',
        sapBusinessTypeName: '',
        sapSaleOrg: ''
      },
      rules: {
        systemName: [
          { required: true, message: '请选择体系名称', trigger: 'change' }
        ],
        businessModel: [
          { required: true, message: '请选择业务模式', trigger: 'change' }
        ],
        deptName: [
          { required: true, message: '请选择经营组织', trigger: 'change' }
        ],
        sapOrderTypeName: [
          { required: true, message: '请选择SAP订单类型', trigger: 'change' }
        ],
        sapProductTypeName: [
          { required: true, message: '请选择SAP项目类别', trigger: 'change' }
        ],
        sapBusinessTypeName: [
          { required: true, message: '请选择SAP客户订单类型', trigger: 'change' }
        ],
        sapSaleOrg: [
          { required: true, message: '请选择SAP销售组织', trigger: 'change' }
        ]
      },
      systemNameOptions: [],
      businessModelOptions: [],
      deptOptions: [],
      sapOrderTypeOptions: [],
      sapProductTypeOptions: [],
      filteredSapProductTypeOptions: [],
      sapBusinessTypeOptions: [],
      sapSaleOrgOptions: [],
      saptempSaleOrgs: [], // 所有SAP销售组织原始数据，用于根据经营组织过滤
      isRestoringEditData: false // 标记是否正在恢复编辑数据
    }
  },
  computed: {
    title () {
      return this.isEdit ? '编辑SAP字段配置' : '新增SAP字段配置'
    },
    isEdit () {
      return !this.$lodash.isEmpty(this.formData)
    }
  },
  mounted () {
    this.initDictData()
  },
  methods: {
    ...mapActions([
      'addOrEditSapFieldConfig',
      'getSapFieldConfigList',
      'queryDictListInfo',
      'querySystemOptionsInfo',
      'queryBusinessOptionsInfo',
      'getAllOrganization'
    ]),
    async initDictData () {
      try {
        // 获取体系名称数据
        this.querySystemOptionsInfo({ status: 0 }).then(res => {
          if (Array.isArray(res) && res.length) {
            this.systemNameOptions = res.map(item => ({ value: item, label: item }))
          }
        })
        // 获取SAP相关字典数据
        const [orderTypeRes, productTypeRes, businessTypeRes, saleOrgRes] = await Promise.all([
          this.queryDictListInfo({ code: 'sapOrderType' }),
          this.queryDictListInfo({ code: 'sapProductTypes' }),
          this.queryDictListInfo({ code: 'sapBusinessType' }),
          this.queryDictListInfo({ code: 'sapSaleOrg' })
        ])
        this.sapOrderTypeOptions = orderTypeRes.data || []
        this.sapProductTypeOptions = productTypeRes.data || []
        this.filteredSapProductTypeOptions = productTypeRes.data || []
        this.sapBusinessTypeOptions = businessTypeRes.data || []
        this.saptempSaleOrgs = saleOrgRes.data || [] // 保存所有原始数据
        this.sapSaleOrgOptions = saleOrgRes.data || [] // 初始显示所有数据
        // 获取经营组织数据
        this.getAllOrganization().then(res => {
          this.deptOptions = res || []
        })
      } catch (error) {
        console.error('初始化字典数据失败:', error)
      }
    },
    handleSystemNameChange (val, keepBusinessModel = false) {
      const originalBusinessModel = this.form.businessModel
      if (!keepBusinessModel) {
        this.form.businessModel = ''
      }
      this.businessModelOptions = []
      if (val) {
        this.queryBusinessOptionsInfo({ deptName: val, status: 0 }).then(res => {
          this.businessModelOptions = (res || []).map(item => ({
            value: item.businessModel,
            label: item.businessModel
          }))
          // 如果是编辑模式且需要保持业务模式，则恢复原值
          if (keepBusinessModel && originalBusinessModel) {
            this.form.businessModel = originalBusinessModel
          }
        })
      }
    },
    handleDeptChange (val) {
      // 查找对应的部门ID
      const dept = this.deptOptions.find(item => item.deptName === val)
      if (dept) {
        this.form.deptId = dept.id
      }

      // 根据经营组织过滤SAP销售组织（与协议页面逻辑保持一致）
      if (val) {
        const filteredSapOrgs = []
        for (let i = 0; i < this.saptempSaleOrgs.length; i++) {
          let item = this.saptempSaleOrgs[i]
          // eslint-disable-next-line eqeqeq
          if (item.def1 == val) {
            filteredSapOrgs.push({ code: item.code, name: item.name })
          }
        }
        this.sapSaleOrgOptions = filteredSapOrgs
        // 只有在非编辑恢复状态下，才清空当前选择的SAP销售组织
        if (!this.isRestoringEditData) {
          this.form.sapSaleOrg = ''
        }
      } else {
        // 如果清空经营组织，恢复显示所有SAP销售组织
        this.sapSaleOrgOptions = this.saptempSaleOrgs
        if (!this.isRestoringEditData) {
          this.form.sapSaleOrg = ''
        }
      }
    },
    handleSapOrderTypeChange (val, isEditRestore = false) {
      // 保存原有的项目类别名称（仅在编辑回显时需要）
      const originalProductTypeName = this.form.sapProductTypeName
      // 清空项目类别选择
      this.form.sapProductTypeName = ''
      // 根据订单类型筛选项目类别（与协议页面逻辑一致）
      const orderType = this.sapOrderTypeOptions.find(item => item.code === val)
      if (orderType) {
        this.form.sapOrderTypeName = orderType.name

        if (orderType.def1) {
          const productTypeCodes = orderType.def1.split(',')
          this.filteredSapProductTypeOptions = this.sapProductTypeOptions.filter(item =>
            productTypeCodes.includes(item.code)
          )
        } else {
          this.filteredSapProductTypeOptions = this.sapProductTypeOptions
        }
        // 仅在编辑回显时恢复项目类别名称
        if (isEditRestore && originalProductTypeName) {
          setTimeout(() => {
            // 现在直接使用name，不需要设置code
            this.form.sapProductTypeName = originalProductTypeName
            console.log('编辑回显设置项目类别名称:', originalProductTypeName)
          }, 100)
        }
        console.log('订单类型联动完成，当前form.sapProductType:', this.form.sapProductType)
        console.log('筛选后的项目类别选项数量:', this.filteredSapProductTypeOptions.length)
      }
    },
    handleSapProductTypeChange (val) {
      // 现在val直接就是name，不需要额外处理
      console.log('用户选择了项目类别名称:', val)
    },
    handleSapBusinessTypeChange (val) {
      // val是code，需要找到对应的name并设置
      const businessType = this.sapBusinessTypeOptions.find(item => item.code === val)
      if (businessType) {
        this.form.sapBusinessTypeName = businessType.name
      }
      console.log('用户选择了客户订单类型:', val, '对应name:', this.form.sapBusinessTypeName)
    },
    handleSapSaleOrgChange (val) {
      // 现在val直接就是name，不需要额外处理
      console.log('用户选择了销售组织名称:', val)
    },
    handleSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          // 确保deptId有值
          if (!this.form.deptId) {
            const dept = this.deptOptions.find(item => item.deptName === this.form.deptName)
            if (dept) {
              this.form.deptId = dept.id
            }
          }
          // 获取对应的code值
          const sapProductType = this.getSapProductTypeCode(this.form.sapProductTypeName)
          const sapSaleOrgCode = this.getSapSaleOrgCode(this.form.sapSaleOrg)
          const submitData = {
            ...this.form,
            sapProductType: sapProductType,
            sapSaleOrgCode: sapSaleOrgCode
            // sapBusinessType 已经是code了，不需要再转换
          }
          console.log('提交的数据:', submitData)

          this.addOrEditSapFieldConfig(submitData).then(() => {
            this.getSapFieldConfigList()
            this.handleClose()
            this.$message({
              type: 'success',
              message: this.isEdit ? '编辑成功!' : '新增成功!'
            })
          })
        } else {
          return false
        }
      })
    },
    handleClose () {
      this.$emit('update:show', false)
    },
    // 获取SAP客户订单类型的code
    getSapBusinessTypeCode (name) {
      if (!name) return ''
      const businessType = this.sapBusinessTypeOptions.find(item => item.name === name)
      return businessType ? businessType.code : ''
    },
    // 获取SAP项目类别的code
    getSapProductTypeCode (name) {
      if (!name) return ''
      // 先从筛选后的选项中查找
      let productType = this.filteredSapProductTypeOptions.find(item => item.name === name)
      // 如果筛选后的选项中没有，再从完整选项中查找
      if (!productType) {
        productType = this.sapProductTypeOptions.find(item => item.name === name)
      }
      return productType ? productType.code : ''
    },
    // 获取SAP销售组织的code
    getSapSaleOrgCode (name) {
      if (!name) return ''
      // 先从当前过滤后的选项中查找
      let saleOrg = this.sapSaleOrgOptions.find(item => item.name === name)
      // 如果过滤后的选项中没有，再从完整选项中查找
      if (!saleOrg) {
        saleOrg = this.saptempSaleOrgs.find(item => item.name === name)
      }
      return saleOrg ? saleOrg.code : ''
    },
    // 恢复编辑数据的方法
    restoreEditData (retryCount = 0) {
      // 如果数据还没加载完成，最多重试3次
      if (this.sapOrderTypeOptions.length === 0 && retryCount < 3) {
        setTimeout(() => {
          this.restoreEditData(retryCount + 1)
        }, 300)
        return
      }
      console.log('开始恢复编辑数据:', this.form)

      // 设置标记，表示正在恢复编辑数据
      this.isRestoringEditData = true

      // 首先处理经营组织，这会触发SAP销售组织的过滤
      if (this.form.deptName) {
        this.handleDeptChange(this.form.deptName)
      }

      // 回显SAP订单类型
      if (this.form.sapOrderTypeName && this.sapOrderTypeOptions.length > 0) {
        const orderType = this.sapOrderTypeOptions.find(item => item.name === this.form.sapOrderTypeName)
        if (orderType) {
          this.form.sapOrderType = orderType.code
          this.handleSapOrderTypeChange(orderType.code, true) // 传入编辑模式标识
          // 编辑回显时，handleSapOrderTypeChange内部已经处理了项目类别的回显
        }
      }

      // 回显SAP客户业务订单类型
      // 优先使用已有的code，避免name重复导致回显错误
      if (this.form.sapBusinessType) {
        // 如果已经有code，直接使用，只需要确保name也正确
        const businessType = this.sapBusinessTypeOptions.find(item => item.code === this.form.sapBusinessType)
        if (businessType) {
          this.form.sapBusinessTypeName = businessType.name
          console.log('编辑回显SAP客户业务订单类型(使用code):', businessType.code, businessType.name)
        }
      } else if (this.form.sapBusinessTypeName && this.sapBusinessTypeOptions.length > 0) {
        // 如果没有code，才基于name去查找（兼容旧数据）
        const businessType = this.sapBusinessTypeOptions.find(item => item.name === this.form.sapBusinessTypeName)
        if (businessType) {
          this.form.sapBusinessType = businessType.code
          console.log('编辑回显SAP客户业务订单类型(使用name):', businessType.code, businessType.name)
        }
      }

      // SAP项目类别和销售组织现在直接使用name，不需要特殊处理
      // 确保编辑时有部门ID
      if (this.form.deptName && !this.form.deptId && this.deptOptions.length > 0) {
        const dept = this.deptOptions.find(item => item.deptName === this.form.deptName)
        if (dept) {
          this.form.deptId = dept.id
        }
      }

      // 恢复完成，重置标记
      this.isRestoringEditData = false
    },
    // 专门处理项目类别回显的方法
    restoreProductType (retryCount = 0) {
      console.log('restoreProductType调用，重试次数:', retryCount)
      console.log('form.sapProductTypeName:', this.form.sapProductTypeName)
      console.log('filteredSapProductTypeOptions.length:', this.filteredSapProductTypeOptions.length)
      if (this.form.sapProductTypeName && this.filteredSapProductTypeOptions.length > 0) {
        console.log('正在处理SAP项目类别:', this.form.sapProductTypeName)
        console.log('可选的项目类别:', this.filteredSapProductTypeOptions)
        let productType = null
        console.log('尝试匹配的项目类别名称:', this.form.sapProductTypeName)
        // 尝试多种匹配方式
        // 方式1: 直接按name匹配
        productType = this.filteredSapProductTypeOptions.find(item => item.name === this.form.sapProductTypeName)
        console.log('方式1匹配结果:', productType)
        // 方式2: 如果是组装格式 "code(name)"，尝试解析
        if (!productType && this.form.sapProductTypeName.includes('(')) {
          const matches = this.form.sapProductTypeName.match(/^(.+?)\((.+)\)$/)
          if (matches) {
            const [, code, name] = matches
            console.log('解析出的code:', code, 'name:', name)
            productType = this.filteredSapProductTypeOptions.find(item => item.code === code || item.name === name)
            console.log('方式2匹配结果:', productType)
          }
        }
        // 方式3: 直接按code匹配
        if (!productType) {
          productType = this.filteredSapProductTypeOptions.find(item => item.code === this.form.sapProductTypeName)
          console.log('方式3匹配结果:', productType)
        }
        // 方式4: 模糊匹配，查找包含关键词的
        if (!productType) {
          productType = this.filteredSapProductTypeOptions.find(item =>
            item.name.includes(this.form.sapProductTypeName) ||
            this.form.sapProductTypeName.includes(item.name)
          )
          console.log('方式4模糊匹配结果:', productType)
        }
        console.log('找到的项目类别:', productType)
        if (productType) {
          this.form.sapProductType = productType.code
          // 不要重新设置sapProductTypeName，保持原有的值
          console.log('成功设置项目类别code:', productType.code)
        } else if (retryCount < 2) {
          // 如果没找到且重试次数少于2次，延迟重试
          console.log('项目类别未找到，重试中...')
          setTimeout(() => {
            this.restoreProductType(retryCount + 1)
          }, 200)
        } else {
          console.log('重试次数已达上限，项目类别回显失败')
        }
      }
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
      // 显示dialog时给form赋初始值
      if (newVal) {
        this.form = this.isEdit ? { ...this.formData } : { ...this.baseForm }
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
        })
        // 如果是编辑模式，需要初始化相关数据
        if (this.isEdit && this.form.systemName) {
          this.handleSystemNameChange(this.form.systemName, true) // 编辑模式下保持业务模式
          // 等待字典数据加载完成后再回显SAP字段
          setTimeout(() => {
            this.restoreEditData()
          }, 500) // 延迟确保数据加载完成
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  margin: 0 auto;
}

.form-input, .form-select, .el-input-number {
  width: 320px;
}
</style>
